/**
 * File: nav.js.
 *
 * Import and initialize functions for Nav specifically for a11y
 */

 export default {
  header: document.querySelector('[data-elementor-type="header"]'),
  init() {
    if (this.header && this.header) {
        this.render();
    }
  },
  render() {
    this.header.addEventListener('focusin', e => {
      const hasDropdown = e.target.parentElement.classList.contains('menu-item-has-children');
      const focusedInDropdown = !!e.target.closest('.qodef-drop-down-second');

      if (hasDropdown || focusedInDropdown) {
        let dropdown = e.target.nextElementSibling;
        if (focusedInDropdown) { 
          dropdown = e.target.closest('.qodef-drop-down-second');
        }
        const height = dropdown.querySelector('.qodef-drop-down-second-inner').offsetHeight;
        dropdown.style.height = height + 'px';
        dropdown.classList.add('qodef-drop-down--start');

        // remove focus on adjacent siblings
        const parent = e.target.closest('.menu-item-has-children');
        const previousSiblingIsADropdown = parent.previousElementSibling ? parent.previousElementSibling.querySelector('.qodef-drop-down-second') : null;
        if (previousSiblingIsADropdown != null) {
          previousSiblingIsADropdown.classList.remove('qodef-drop-down--start');
        }
        const nextSiblingIsADropdown = parent.nextElementSibling ? parent.nextElementSibling.querySelector('.qodef-drop-down-second') : null;
        if (nextSiblingIsADropdown != null) {
          nextSiblingIsADropdown.classList.remove('qodef-drop-down--start');
        }
      }

      else {
        const dropdowns = document.querySelectorAll('.qodef-drop-down-second');
        dropdowns.length > 0 && dropdowns.forEach(el => {
          el.classList.remove('qodef-drop-down--start');
        })
      }
    });
    
    // removes Sticket header from VO and tab-index
    this.header.querySelector('.qodef-header-sticky').setAttribute('aria-hidden', 'true');
    const stickyHeaderElements = this.header.querySelectorAll('.qodef-header-sticky a');
    stickyHeaderElements.forEach(el => {
      el.tabIndex = -1;
      el.ariaHidden = true;
    });
    
  },
  finalize() {
  // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
